import { createSelector } from 'reselect';
import filter from 'lodash/filter';

const getGroups = state => state.groups.list;
const getSearchText = state => state.groups.filter;

/**
  @name getFilteredGroups
  Selector to obtain the searched groups from the list
*/
const getFilteredGroups = createSelector(getGroups, getSearchText, (groups, text) => {
  if (text) {
    const list = filter(groups, group => group.name.toLowerCase().includes(text.toLowerCase()))
    return list;
  }
  return groups;
});

export default getFilteredGroups;



// WEBPACK FOOTER //
// ./src/utils/selectors/getFilteredGroups.js